// Palette partagée par tous les écrans. Chaque valeur renvoie à un jeton CSS défini dans
// index.css (clair ET sombre) : un écran ne connaît jamais la couleur effective, ce qui permet au
// mode sombre de la tablette de s'appliquer partout sans condition dans le code.
export const ACCENT = 'var(--aqs-accent)';
export const ACCENT_PRESSE = 'var(--aqs-accent-presse)';
export const ACCENT_FOND = 'var(--aqs-accent-fond)';
export const ACCENT_BORD = 'var(--aqs-accent-bord)';
export const SUR_ACCENT = 'var(--aqs-sur-accent)';

export const VERT = 'var(--aqs-vert)';
export const VERT_FG = 'var(--aqs-vert-texte)';
export const VERT_BG = 'var(--aqs-vert-fond)';
export const AMBRE = 'var(--aqs-orange)';
export const AMBRE_FG = 'var(--aqs-orange-texte)';
export const AMBRE_BG = 'var(--aqs-orange-fond)';
export const AMBRE_BORDER = 'var(--aqs-orange-bord)';
export const ROUGE = 'var(--aqs-rouge)';
export const ROUGE_FG = 'var(--aqs-rouge-texte)';
export const ROUGE_BG = 'var(--aqs-rouge-fond)';
export const ROUGE_BORDER = 'var(--aqs-rouge-bord)';
export const NEUTRE = 'var(--aqs-neutre)';

export const TEXTE = 'var(--aqs-texte)';
export const TEXTE_SECONDAIRE = 'var(--aqs-texte-2)';
export const TEXTE_MUET = 'var(--aqs-texte-3)';
export const TEXTE_DESACTIVE = 'var(--aqs-texte-4)';

export const FOND_APP = 'var(--aqs-fond)';
export const SURFACE = 'var(--aqs-surface)';
export const SURFACE_2 = 'var(--aqs-surface-2)';
export const REMPLISSAGE = 'var(--aqs-remplissage)';
export const REMPLISSAGE_2 = 'var(--aqs-remplissage-2)';
export const SEPARATEUR = 'var(--aqs-separateur)';
export const SEPARATEUR_FORT = 'var(--aqs-separateur-fort)';

export const OMBRE_CARTE = 'var(--aqs-ombre-carte)';
export const OMBRE_FLOTTANT = 'var(--aqs-ombre-flottant)';

// Rayons « continus » : plus la surface est grande, plus l'arrondi est ample.
export const RAYON_CARTE = 18;
export const RAYON_GROUPE = 14;
export const RAYON_BOUTON = 12;
export const RAYON_CHAMP = 10;

// Cible tactile minimale : jamais sous 44 px, quel que soit le palier.
export const CIBLE = 44;
